const PASSWORD_KEY_PREFIX = "onboarding-dgi-portal-password-";
const MANUAL_FALLBACK_KEY_PREFIX = "onboarding-dgi-manual-fallback-";
const STEPS_COMPLETED_KEY_PREFIX = "onboarding-dgi-steps-completed-";
const STEP3_CONTINUED_KEY_PREFIX = "onboarding-dgi-step3-continued-";

export function readDgiPortalPasswordFromSession(tenantId: string): string | null {
  try {
    const v = sessionStorage.getItem(PASSWORD_KEY_PREFIX + tenantId);
    return v != null && v.length > 0 ? v : null;
  } catch {
    return null;
  }
}

export function writeDgiPortalPasswordToSession(
  tenantId: string,
  password: string,
): void {
  try {
    sessionStorage.setItem(PASSWORD_KEY_PREFIX + tenantId, password);
  } catch {
    /* ignore quota / private mode */
  }
}

/**
 * Three-state read of the manual-fallback choice: `true` = user is in manual,
 * `false` = user explicitly chose automatic, `null` = no choice made yet. The
 * null case lets the caller seed the initial view from a durable backend signal
 * (e.g. the auto portal_user step already failed) without overriding an explicit
 * "go automatic" the user made and that must survive reloads.
 */
export function readDgiManualFallbackRawFromSession(
  tenantId: string,
): boolean | null {
  try {
    const v = sessionStorage.getItem(MANUAL_FALLBACK_KEY_PREFIX + tenantId);
    if (v === "1") return true;
    if (v === "0") return false;
    return null;
  } catch {
    return null;
  }
}

export function writeDgiManualFallbackToSession(
  tenantId: string,
  manual: boolean,
): void {
  try {
    // Store "0" (not removeItem) for explicit-automatic so it's distinguishable
    // from "never chose" (absent) — see readDgiManualFallbackRawFromSession.
    sessionStorage.setItem(MANUAL_FALLBACK_KEY_PREFIX + tenantId, manual ? "1" : "0");
  } catch {
    /* ignore */
  }
}

export function clearDgiPortalPasswordFromSession(tenantId: string): void {
  try {
    sessionStorage.removeItem(PASSWORD_KEY_PREFIX + tenantId);
  } catch {
    /* ignore */
  }
}

export function readDgiStepsCompletedFromSession(tenantId: string): boolean {
  try {
    return sessionStorage.getItem(STEPS_COMPLETED_KEY_PREFIX + tenantId) === "1";
  } catch {
    return false;
  }
}

export function writeDgiStepsCompletedToSession(
  tenantId: string,
  completed: boolean,
): void {
  try {
    if (completed) {
      sessionStorage.setItem(STEPS_COMPLETED_KEY_PREFIX + tenantId, "1");
    } else {
      sessionStorage.removeItem(STEPS_COMPLETED_KEY_PREFIX + tenantId);
    }
  } catch {
    /* ignore */
  }
}

export function readDgiStep3ContinuedFromSession(tenantId: string): boolean {
  try {
    return sessionStorage.getItem(STEP3_CONTINUED_KEY_PREFIX + tenantId) === "1";
  } catch {
    return false;
  }
}

export function writeDgiStep3ContinuedToSession(tenantId: string): void {
  try {
    sessionStorage.setItem(STEP3_CONTINUED_KEY_PREFIX + tenantId, "1");
  } catch {
    /* ignore */
  }
}

export function clearDgiOnboardingSession(tenantId: string): void {
  try {
    sessionStorage.removeItem(PASSWORD_KEY_PREFIX + tenantId);
    sessionStorage.removeItem(MANUAL_FALLBACK_KEY_PREFIX + tenantId);
    sessionStorage.removeItem(STEPS_COMPLETED_KEY_PREFIX + tenantId);
    sessionStorage.removeItem(STEP3_CONTINUED_KEY_PREFIX + tenantId);
  } catch {
    /* ignore */
  }
}
